import React from "react";

const LoadingComponent = () => {
  return (
    <p className="placeholder-glow">
      <span className="placeholder col-12"></span>
    </p>
  );
};

export default LoadingComponent;
